// Sidebar.jsx - Update the sidebar with new styles
import React from "react";
import { Box, List, ListItem, ListItemIcon, ListItemText, Divider, Typography, Toolbar } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import useAuth from "../../hooks/useAuth";

function Sidebar() {
	const { user, isAdmin, logout } = useAuth();
	const navigate = useNavigate();
	const canCreateBot = isAdmin() || user?.permissions?.includes("create_bot");

	const handleLogout = () => {
		logout();
		navigate("/login");
	};

	const navItems = [
		{ text: "Dashboard", icon: <DashboardOutlinedIcon />, path: "/" },
		{ text: "My Bots", icon: <CodeOutlinedIcon />, path: "/bots" },
		...(canCreateBot ? [{ text: "Add Bot", icon: <AddOutlinedIcon />, path: "/bots/new" }] : []),
	];

	const adminItems = [{ text: "Users", icon: <PeopleOutlinedIcon />, path: "/admin/users" }];

	return (
		<Box sx={{ py: 2, height: "100%", display: "flex", flexDirection: "column" }}>
			<Toolbar>
				<Typography variant="h6" color="#6c5ce7" fontWeight="bold">
					BotManager
				</Typography>
			</Toolbar>

			<List>
				{navItems.map((item) => (
					<ListItem
						button
						component={NavLink}
						to={item.path}
						end={item.path === "/"}
						key={item.text}
						sx={{
							mb: 1,
							borderRadius: "8px",
							mx: 1,
							"&.active": {
								backgroundColor: "#6c5ce7",
								color: "white",
								"& .MuiListItemIcon-root": {
									color: "white",
								},
							},
						}}
					>
						<ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
						<ListItemText primary={item.text} />
					</ListItem>
				))}
			</List>

			{isAdmin() && (
				<>
					<Box sx={{ px: 2, mb: 1, mt: 2 }}>
						<Typography variant="caption" color="text.secondary" sx={{ fontWeight: "bold" }}>
							ADMIN
						</Typography>
					</Box>

					<List>
						{adminItems.map((item) => (
							<ListItem
								button
								component={NavLink}
								to={item.path}
								key={item.text}
								sx={{
									mb: 1,
									borderRadius: "8px",
									mx: 1,
									"&.active": {
										backgroundColor: "#6c5ce7",
										color: "white",
										"& .MuiListItemIcon-root": {
											color: "white",
										},
									},
								}}
							>
								<ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
								<ListItemText primary={item.text} />
							</ListItem>
						))}
					</List>
				</>
			)}

			<Box sx={{ mt: "auto", p: 2 }}>
				<ListItem button onClick={handleLogout} sx={{ borderRadius: "8px" }}>
					<ListItemIcon>
						<LogoutOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Logout" />
				</ListItem>
			</Box>
		</Box>
	);
}

export default Sidebar;
